<template>
  <section class="report-section">
    <b-row>
      <b-col>
        <h3>{{ index }}.1 Riepilogo consumi {{ vectorName }}</h3>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col>
        <table>
          <tr>
            <td class="text-right"><h4>{{ curMonth }} {{ currentYear }}</h4></td>
            <td></td>
            <td><h4>CUMULATO {{ currentYear }}</h4></td>
          </tr>
          <tr>
            <td class="text-right">
              <strong>{{ f(curMonthValue, 0) }}</strong>
              <span>Fabbisogno {{ vector }}</span>
            </td>
            <td class="text-center text-top"><strong>[{{ vectorMu }}]</strong></td>
            <td>
              <strong>{{ f(yearValue, 0) }}</strong>
              <span>Fabbisogno {{ vector }}</span>
            </td>
          </tr>
          <tr>
            <td class="text-right">
              <strong>{{ f(curMonthCost, 0) }}</strong>
              <span>Costo {{ vector }}</span>
            </td>
            <td class="text-center text-top"><strong>€</strong></td>
            <td>
              <strong>{{ f(yearCost, 0) }}</strong>
              <span>Costo {{ vector }}</span>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <table class="grid">
      <tr>
        <td class="col-tiny">
          <h3 class="in-page-title">Dettaglio:<br>
            <span>consumi {{ vector }}<br>
            a confronto</span>
          </h3>
        </td>
        <td class="report-arrow"><img src="/static/report/arrow.png"></td>
        <td>
          <div class="pie-wrap">
            <apexchart type="bar" :options="chart.options" :series="chart.series" />
          </div>
        </td>
      </tr>
    </table>

    <categories :siteGuid="siteGuid" :month="month" :index="index" :vector="vector" />
  </section>
</template>

<script>
import Categories from './E1_Summary'

var moment = require('moment');

export default {
  name: "EnergySummary",
  props: ['siteGuid', 'month', 'index', 'vector'],
  components: { Categories },
  data() {
    return {
      currentYear: 0,
      firstYear: 0,
      curMonth: '',
      curMonthValue: 0,
      curMonthCost: 0,
      yearValue: 0,
      yearCost: 0,
      chart: {
        options: {
          colors: this.$store.state.colors,
          chart: {
            toolbar: {
              show: false
            },
            height: 240,
            width: 640,
            animations: {
              enabled: false
            }
          },
          xaxis: {
            categories: []
          },
          dataLabels: {
            enabled: false
          }
        },
        series: []
      },
    }
  },
  created() {
    this.curMonth = moment(this.month, 'MM-YYYY').format('MMMM')
    this.currentYear = parseInt(moment(this.month, 'MM-YYYY').format('YYYY'))
    this.firstYear = this.currentYear - 2
    this.reload()
  },

  methods: {
    ff(v) {
      if(v && ! isNaN(v)) {
        return this.sign(v) + v.toFixed(2) + "%"
      }
    },
    f(v, prec) {
      return this.$options.filters.formatDecimal(v, prec)
    },
    sign(v) {
      if(v > 0)
        return "+"
    },
    reload() {
      var params = {
        fromMonth: '01-' + this.firstYear,
        toMonth: this.month,
        siteGuid: this.siteGuid,
        vector: this.vector
      }

      this.$store.dispatch('report/summary', params).then(data => {

        var last = _.cloneDeep(data.items).pop()
        this.curMonthValue = last.value
        this.curMonthCost = last.cost

        _.filter(data.items, { year: this.currentYear }).forEach( e => {
          this.yearCost += e.cost
          this.yearValue += e.value
        })

        this.chart.series = []
        let years = _.sortedUniq(data.items.map(e => e.year))
        years.forEach(y => {
          this.chart.series.push({
            name: y,
            data: _.filter(data.items, { year : y }).map(ee => ee.value)
          })
        })

        var options = _.cloneDeep(this.chart.options)
        options.xaxis.categories = this.monthLabels
        this.chart.options = options
      })
    }
  },

  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
    vectorName() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).name
    },
    vectorMu() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).mu
    }
  },

  watch: {
    month() {
      this.curMonth = moment(this.month, 'MM-YYYY').format('MMMM')
      this.currentYear = parseInt(moment(this.month, 'MM-YYYY').format('YYYY'))
      this.firstYear = this.currentYear - 2
      this.reload()
    }
  }
}
</script>

<style scoped>
  table {
    margin: 20px auto;
  }
  table td {
    padding: 10px;
  }
  h4 {
    color: #089BAF;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom:0;
  }
  strong {
    font-size: 44px;
    display: block;
  }
  h3 span {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/Report/E_Summary.vue